import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import Buefy from 'buefy'
import EventBus from './EventBus'
import Sticky from 'vue-sticky-directive'
//import './plugins/firebase'

const uuid = require('uuid/v4')

const mixin = {
  methods: {
    createUuId: uuid,
  },
}
//Vue.use(introJs)
//Vue.use(VueIntro)
Vue.use(Sticky)
Vue.mixin(mixin)
Vue.use(EventBus)
Vue.use(Buefy, {
  defaultIconPack: 'mdi',
  defaultContainerElement: '#app',
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
